import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    requestId: 0,
    pendingSessionId: null,
    source: null,
};

const sessionLoaderSlice = createSlice({
    name: 'sessionLoader',
    initialState,
    reducers: {
        requestLoad(state, action) {
            state.requestId += 1;
            state.pendingSessionId = action.payload.sessionId;
            state.source = action.payload.source || 'manual';
        },
        consumeLoad(state) {
            state.pendingSessionId = null;
            state.source = null;
        },
    },
});

export const { requestLoad, consumeLoad } = sessionLoaderSlice.actions;
export default sessionLoaderSlice.reducer;

export const selectLoadRequest = (state) => state.sessionLoader;
